const lang = "en";
// const lang = "he";
export default lang;
